import { useQuery } from '@tanstack/react-query';
import { getKeyMetrics } from '../api/dashboard';

/**
 * Key metrics for the console dashboard. Refetched on every visit — the server caches the counts,
 * so a lender created or blocked a moment ago shows up without waiting for the client cache.
 */
export function useKeyMetrics() {
  return useQuery({
    queryKey: ['dashboard', 'key-metrics'],
    queryFn: getKeyMetrics,
    staleTime: 0,
    refetchInterval: 5 * 60_000,
  });
}
